
<div class="relative w-full py-6 px-2">

  <verisk-table-component 
    [rowData]="resRender"
    [colData]="colRender"
    [rowUpdate]="rowUpdate"
    [isLoading]="isLoading()"
    [tableOptions]="{
      enableRowSelection: true,
      enableMultiRowSelection: true,
      initialPageSize: 10,
      showActionMenu: true,
      enableColumnPinning: true,
      enableColumnResizing: true,
      enableGlobalFilter: true,
      enableSorting: true,
    }">
  </verisk-table-component>
</div>